module.exports = __webpack_public_path__ + "static/media/location.e708a481.svg";